const PUBLIC_API_DOMAIN = "miramarketlabs.com";

function getRuntimeApiDomain() {
  const hostname = window.location.hostname;
  if (hostname === PUBLIC_API_DOMAIN || hostname.endsWith(`.${PUBLIC_API_DOMAIN}`)) {
    return PUBLIC_API_DOMAIN;
  }
  return PUBLIC_API_DOMAIN;
}

function buildPublicApiBaseUrl(subdomain, path) {
  return `https://${subdomain}.${getRuntimeApiDomain()}${path}`;
}

const PUBLIC_DECISION_API_BASE_URL = buildPublicApiBaseUrl("decision", "/ltapi/de/v1");
const PUBLIC_MARKET_API_BASE_URL = buildPublicApiBaseUrl("market", "/ltapi/md/v1");
const LOCAL_DECISION_API_BASE_URL = "http://localhost:8083/ltapi/de/v1";
const LOCAL_MARKET_API_BASE_URL = "http://localhost:8081/ltapi/md/v1";

function isLocalHost(value) {
  return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\b/i.test(value ?? "");
}

function isLocalBrowser() {
  return ["localhost", "127.0.0.1"].includes(window.location.hostname);
}

function resolveApiBaseUrl(configuredUrl, publicUrl, localUrl) {
  if (!configuredUrl) return isLocalBrowser() ? localUrl : publicUrl;
  if (!isLocalBrowser() && isLocalHost(configuredUrl)) return publicUrl;
  return configuredUrl;
}

const API_BASE_URL = resolveApiBaseUrl(
  process.env.REACT_APP_DECISION_API_BASE_URL,
  PUBLIC_DECISION_API_BASE_URL,
  LOCAL_DECISION_API_BASE_URL
);
const MARKET_API_BASE_URL = resolveApiBaseUrl(
  process.env.REACT_APP_MARKET_API_BASE_URL,
  PUBLIC_MARKET_API_BASE_URL,
  LOCAL_MARKET_API_BASE_URL
);

const API_ENDPOINTS = {
  DA_FILTER: `${MARKET_API_BASE_URL}/analysis/find/stocks/filter`,
  STOCK_CHART: `${MARKET_API_BASE_URL}/analysis/find/stock`,
  INDUSTRY_LIST: `${MARKET_API_BASE_URL}/analysis/find/industry`,
  SECTOR_LIST: `${MARKET_API_BASE_URL}/analysis/find/sector`,
  PERFORMANCE_LIST: `${MARKET_API_BASE_URL}/analysis/market/performance`,
  NSE_WEEKLY_TREND: `${MARKET_API_BASE_URL}/analysis/market/nse-weekly-trend`,
  DA_STOCK_SIGNALS: `${MARKET_API_BASE_URL}/analysis/stocks/sentiment`,
  UPDATE_STOCK: `${MARKET_API_BASE_URL}/analysis/stock/update`,
  BIGPIC_CHART: `${MARKET_API_BASE_URL}/chart/find/bigChart`,
  NORMALIZE_CHART: `${MARKET_API_BASE_URL}/chart/find/normalize`,
  HM_STK_HILIGHT: `${MARKET_API_BASE_URL}/board/market/stock/highlights`,
  HM_NEG_STK_HILIGHT: `${MARKET_API_BASE_URL}/board/market/stock/negative/highlights`,
  HM_IDS_HILIGHT: `${MARKET_API_BASE_URL}/board/market/industry/highlights`,
  ADVISOR_DESK: `${API_BASE_URL}/ai-advisor/daily-desk`,
  ADVISOR_DESK_REFRESH: `${API_BASE_URL}/ai-advisor/daily-desk/refresh`,
  SIGNAL_LAB: `${API_BASE_URL}/ai-advisor/signal-lab`,
  MARKET_BIAS_REFRESH_INPUTS: `${API_BASE_URL}/admin/market-bias/refresh-inputs`,
  MARKET_BIAS_APPLY_GLOBAL_SCORE: `${API_BASE_URL}/admin/market-bias/apply-global-score`,
  MARKET_BIAS_LATEST_APPLIED: `${API_BASE_URL}/admin/market-bias/latest-applied`,
  SIGNAL_RULES: `${API_BASE_URL}/ai-advisor/signal-rules`,
  STRATEGY_RULE_CONFIG: `${API_BASE_URL}/ai-advisor/strategy-rules`,
  STRATEGY_ADMIN: `${API_BASE_URL}/admin/strategies`,
  STOCK_PICK: `${API_BASE_URL}/ai-advisor/stocks/pick`,
  STRATEGY_STOCK_PICK: `${API_BASE_URL}/ai-advisor/stocks/strategy-pick`,
  TRADEABILITY_DESK: `${API_BASE_URL}/ai-advisor/stocks/tradeability-desk`,
  TRADEABILITY_REFRESH_ONE: `${API_BASE_URL}/ai-advisor/stocks/tradeability-refresh-one`,
  NSE_TRADEABILITY_REFRESH_ONE: `${API_BASE_URL}/nse/tradeability/refresh-one`,
  NSE_TRADEABILITY_REFRESH_DUE: `${API_BASE_URL}/nse/tradeability/refresh-due`,
  EVENTS: `${API_BASE_URL}/ai-advisor/events`,
  ENABLED_EVENTS: `${API_BASE_URL}/ai-advisor/events/enabled`,
  STOCK_DETAIL: `${MARKET_API_BASE_URL}/analysis/find/stock`,
};

export default API_ENDPOINTS;
